import { CustomerClassifications } from '@mews-commander/data-access';
import { LocalizedEnum } from '@mews/framework';
import { IconName, Tag } from '@optimus-web/core';

export interface GuestClassificationTagProps {
    enumValue: CustomerClassifications;
    iconName: IconName | undefined;
}
// TODO: update with new EnumLocalization once new type for CustomerProfileClassifications is generated
export const GuestClassificationTag = ({ enumValue, iconName }: GuestClassificationTagProps) => (
    <Tag leadingIcon={iconName} variant="basicSubtle">
        <LocalizedEnum prefix="CustomerClassifications" value={enumValue} />
    </Tag>
);
